export const environment = {
  production: true,
  clientUrl: "https://tracking.fleetdynamics.com.au",
  apiUrl: "https://fleetdynamics.azure-api.net/portal-prod-api",
  googleMapKey: "AIzaSyApHMg4jqyr7x3LFlg2G7cgX7Yyg-4_vRY",
  bingMapKey:
    "AuuH9WTrwpaTgOMCYzrJBNrVDyK0BbUjMyH_4xkHdAWhNFS6mO-3LNBBwpJbfYBn",
  b2cConfig: {
    authority:
      "https://fleetdynamicsb2c.b2clogin.com/fleetdynamicsb2c.onmicrosoft.com/B2C_1_singinup",
    accessTokenEndpoint:
      "https://fleetdynamicsb2c.b2clogin.com/fleetdynamicsb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_singinup",
    tenant: "fleetdynamicsb2c.onmicrosoft.com",
    clientID: "3b73f583-56c3-4664-a677-c0bb1b9d2ac0",
    signInSignOutPolicy: "B2C_1_singinup",
    logoutEndpoint:
      "https://fleetdynamicsb2c.b2clogin.com/fleetdynamicsb2c.onmicrosoft.com/oauth2/v2.0/logout",
    redirectUri: "https://tracking.fleetdynamics.com.au/",
    redirectUriMobile:
      "msauth://com.fleetcare.fleetdynamics/ga0RGNYHvNM5d0SLGQfpQWAPGJ8%3D",
    b2cScopes: ["https://fleetdynamicsb2c.onmicrosoft.com/api/app.read"],
  },

  securePayClientId: "dyWnhmF1Lzno1slvoLGTDczWvQfvnbpI",
  securePayMerchantCode: "FDM0024",
};
